/**
 * ErrorScreen.tsx
 * Error screen
 */

import { type FC } from 'react';

import { Button } from '@skillarea/lib-frontend';
import { Title, TextBlock } from '@skillarea/lib-frontend';
import { useTranslation } from 'react-i18next';

import styles from '../MatchmakingModal.module.scss';

import { translateMatchmakingError } from '~/lib/matchmakingLocale';

export interface IErrorScreenProps {
  error: string | null;
  onRetry: () => void;
}

export const ErrorScreen: FC<IErrorScreenProps> = ({ error, onRetry }) => {
  const { t } = useTranslation('matchmaking');

  return (
    <div className={styles.screen}>
      <div className={`${styles.centered} ${styles.resultScreen}`}>
        <div className={styles.resultIcon}>
          <span className={styles.emoji}>⚠️</span>
        </div>

        <TextBlock className={styles.resultText} size="l">
          {translateMatchmakingError(t, error)}
        </TextBlock>

        <Title className={styles.resultTitle} color="contrast" variant="benzin">
          {t('error.title')}
        </Title>
      </div>

      <div className={styles.footer}>
        <div className={styles.actionButtons}>
          <Button
            className={styles.actionButton}
            color="accent"
            name={t('error.retry')}
            onClick={onRetry}
            size="s"
            variant="filled"
          >
            {t('error.retry')}
          </Button>
        </div>
      </div>
    </div>
  );
};
